var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuggestPart',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":"title","itemsKey":"tariffs","fetchData":_vm.fetchData},scopedSlots:_vm._u([{key:"action",fn:function({
        init
      }){return [(_vm.createButton)?[_c('Create',{attrs:{"small":true},on:{"onCreate":init}}),_vm._v("   ")]:_vm._e()]}}])},'SuggestPart',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }